import {MODEL_FIELD_DISPLAY_NAME} from 'instruments/equipment/EquipmentConstants';
import {EquipmentTypedModel, EquipmentTypedValue} from 'procedures/ProcedureDomainTypes';
import {BioentityForProcedure} from 'procedures/utils/useBioentitiesForProcedures';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

/**
 * Shared validation method to validate the model schema tag is present for the equipmentTypedValue and is
 * present in the modelsTypedValue target files.
 *
 * @param equipmentTypedValue
 * @param modelsTypedValue
 * @param bioentitiesForProcedures
 */
export function isEquipmentValidWithModel(
  equipmentTypedValue: EquipmentTypedValue,
  modelsTypedValue: EquipmentTypedModel,
  bioentitiesForProcedures: Array<BioentityForProcedure>
): boolean {
  // Only run this validation for when model and planned value are specified and correct type. There are other
  // methods to validate the individual columns
  if (
    equipmentTypedValue.type !== FieldType.BIOENTITY_LINK ||
    equipmentTypedValue.targetFiles.length === 0 ||
    modelsTypedValue.type !== FieldType.BIOENTITY_LINK ||
    modelsTypedValue.targetFiles.length === 0
  ) {
    return true;
  }
  const equipmentValueEntity = bioentitiesForProcedures.find(
    (entity) => entity.id === equipmentTypedValue.targetFiles[0].id
  );
  if (equipmentValueEntity !== undefined) {
    // validate model entity linked to planned value is specified in equipment models
    const plannedValueModelTag = equipmentValueEntity.tags.find(
      (tag) => tag.name === MODEL_FIELD_DISPLAY_NAME
    );
    const linkedEquipmentModelTargetFiles = plannedValueModelTag?.targetFiles;
    const isEntityWithoutModel =
      linkedEquipmentModelTargetFiles == null || linkedEquipmentModelTargetFiles.length === 0;
    if (
      isEntityWithoutModel ||
      !modelsTypedValue.targetFiles
        .map((targetFile) => targetFile.id)
        .find((allowedId) => allowedId === linkedEquipmentModelTargetFiles[0].id)
    ) {
      return false;
    }
  }
  return true;
}
